import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  DATA_PERSONS_FEATURE_KEY,
  DATA_WORKSHOPS_FEATURE_KEY,
  DATA_MODULES_FEATURE_KEY,
  dataPersonsReducer,
  dataWorkshopsReducer,
  dataModulesReducer,
} from './+state/reducers';
import {
  DataWorkshopWorkshopsListPageEffects,
  DataWorkshopModulesListPageEffects,
  DataModuleModulesListPageEffects,
  DataModuleModulePageEffects,
  DataPersonPersonsListPageEffects,
  DataPersonModulesListPageEffects,
} from './+state/effects';
import { DataService, DataBlobService } from './+state/services';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(DATA_WORKSHOPS_FEATURE_KEY, dataWorkshopsReducer),
    StoreModule.forFeature(DATA_MODULES_FEATURE_KEY, dataModulesReducer),
    StoreModule.forFeature(DATA_PERSONS_FEATURE_KEY, dataPersonsReducer),
    EffectsModule.forFeature([
      DataModuleModulePageEffects,
      DataModuleModulesListPageEffects,
      DataWorkshopWorkshopsListPageEffects,
      DataWorkshopModulesListPageEffects,
      DataPersonPersonsListPageEffects,
      DataPersonModulesListPageEffects,
    ]),
  ],
  providers: [DataService, DataBlobService],
})
export class DataDataAccessModule {}
